module.exports = __webpack_public_path__ + "fonts/5d5f674bab2f5f07090d263326ea1e82.svg";